/* Shared behavior for all card-product-v2 cards, loaded once per page.
   Document-level delegation (capture-phase scroll, bubbling change) means
   cards mounted later from deferred grid templates are covered without any
   per-card wiring. The only per-card work left inline in the snippet is
   radio-name uniquification, which must run at insert time so twin cards
   of the same product render the correct initial checked state. */
(function () {
  if (window.__cpv2Delegated) return;
  window.__cpv2Delegated = true;

  /* Gallery progress bar. Scroll does not bubble, but capture-phase
     listeners on the document still observe every scroller — same
     technique as the PLP gallery delegation in castiron-plp-card.liquid.
     With 2 slides the bar is 50% wide and slides from left:0% to 50%. */
  document.addEventListener('scroll', function (e) {
    var track = e.target;
    if (!track || !track.matches || !track.matches('[data-cpv2-track]')) return;
    var card = track.closest('.cpv2');
    var bar = card && card.querySelector('[data-cpv2-progress-bar]');
    if (!bar) return;
    var max = track.scrollWidth - track.clientWidth;
    var frac = max > 0 ? (track.scrollLeft / max) : 0;
    bar.style.left = (frac * 50) + '%';
  }, { capture: true, passive: true });

  /* Variant-image sync — swap the two slide images when the card's hidden
     variant id changes. Deferred a tick so the variant picker has already
     written the new id by the time it is read. */
  document.addEventListener('change', function (e) {
    var card = e.target.closest && e.target.closest('.cpv2');
    if (!card) return;
    setTimeout(function () {
      var track = card.querySelector('[data-cpv2-track]');
      var mapEl = card.querySelector('[data-cpv2-variant-images]');
      var idInp = card.querySelector('input[name="id"]');
      if (!track || !mapEl || !idInp) return;
      var map;
      try { map = JSON.parse(mapEl.textContent); } catch (err) { return; }
      var pair = map[idInp.value];
      if (!pair) return;
      var imgs = card.querySelectorAll('[data-cpv2-slide-img]');
      /* srcset would override the assigned src at render time — strip it
         first, as global.js's variant-image path does. */
      if (imgs[0] && pair[0]) { imgs[0].removeAttribute('srcset'); imgs[0].src = pair[0]; }
      if (imgs[1]) { imgs[1].removeAttribute('srcset'); imgs[1].src = pair[1] || pair[0]; }
      track.scrollTo({ left: 0, behavior: 'smooth' });
    }, 0);
  });

  /* Swatch radio uniquification — one pass per rendered card instance.
     The same product card rendered more than once on a page (featured-
     collection tabs, subcollection groups) ships identical radio names AND
     ids: the browser then treats every copy as ONE radio group (selecting
     a swatch on one card clears its twin) and a label click resolves its
     for= against the FIRST duplicate id in the document. Renaming must
     also cover cards mounted later (template clones, AJAX groups) — a
     cloned inline <script> never re-executes, which is exactly how the old
     per-card uniquifier broke — so the pass lives here, driven by a
     MutationObserver on insertions. */
  var seq = 0;
  function uniquifyCard(card) {
    if (card.hasAttribute('data-swatch-uniquified')) return;
    card.setAttribute('data-swatch-uniquified', '');
    var inputs = card.querySelectorAll('input[type="radio"].swatch-input__input');
    if (!inputs.length) return;
    var suffix = '-i' + (++seq);
    inputs.forEach(function (inp) {
      if (inp.id) {
        var esc = window.CSS && CSS.escape ? CSS.escape(inp.id) : inp.id;
        var label = card.querySelector('label[for="' + esc + '"]');
        inp.id += suffix;
        if (label) label.setAttribute('for', inp.id);
      }
      inp.name += suffix;
    });
    /* While duplicate names coexisted during parse the browser kept only
       the LAST checked radio of each colliding group — restore this
       card's authored selection now that its group is isolated. */
    inputs.forEach(function (inp) {
      if (inp.defaultChecked && !inp.checked) inp.checked = true;
    });
  }
  function uniquifyWithin(root) {
    if (!root || root.nodeType !== 1) return;
    if (root.matches('.cpv2, .plp-card')) uniquifyCard(root);
    root.querySelectorAll('.cpv2, .plp-card').forEach(uniquifyCard);
  }
  function startUniquify() {
    uniquifyWithin(document.body);
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) uniquifyWithin(added[j]);
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startUniquify);
  } else {
    startUniquify();
  }
})();


